import {
  resolveAdminPwaAppleTitle,
  resolveAdminPwaInstallSurface,
  resolveAdminPwaManifestHref,
  type AdminPwaInstallSurface,
} from './adminPwaSurfaces.js';

export interface SyncAdminPwaDocumentChromeResult {
  readonly surface: AdminPwaInstallSurface;
  readonly manifestHref: string;
}

/**
 * Points `link[rel=manifest]` (and Apple title) at the tenant or Dev PWA
 * for the current path. Removes duplicate manifest links so Chromium sees one app id.
 */
export function syncAdminPwaDocumentChrome(
  pathname: string,
  doc: Document = document,
): SyncAdminPwaDocumentChromeResult {
  const surface = resolveAdminPwaInstallSurface(pathname);
  const manifestHref = resolveAdminPwaManifestHref(surface);
  const appleTitle = resolveAdminPwaAppleTitle(surface);

  const links = Array.from(doc.querySelectorAll('link[rel="manifest"]'));
  let keep = links[0] ?? null;
  for (let i = 1; i < links.length; i += 1) {
    const extra = links[i];
    if (extra !== undefined) {
      extra.parentNode?.removeChild(extra);
    }
  }
  if (keep === null) {
    keep = doc.createElement('link');
    keep.setAttribute('rel', 'manifest');
    doc.head.appendChild(keep);
  }
  if (keep.getAttribute('href') !== manifestHref) {
    keep.setAttribute('href', manifestHref);
  }

  const apple = doc.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (apple !== null && apple.getAttribute('content') !== appleTitle) {
    apple.setAttribute('content', appleTitle);
  }

  return { surface, manifestHref };
}
